import React from "react";
import { cn } from "./cn";
import { PASSWORD_RULES, passwordScore } from "./passwordRules";
import { CheckIcon } from "../../../assets/ui/icons";

/* Live password checklist. Each rule turns green with a tick as it passes, so the user can see which requirement is still outstanding rather than guessing... */
export const PasswordRequirements = ({ value = "", className = "" }) => {
  const score = passwordScore(value);
  const total = PASSWORD_RULES.length;
  const complete = score === total;

  return (
    <div
      className={cn(
        "mt-1.5 p-3.5 rounded-[10px] bg-[var(--field-inset)] border border-[var(--field-inset-border)]",
        className
      )}
    >
      <div className="flex items-center justify-between mb-2.5">
        <span className="text-[12px] font-bold uppercase tracking-[.04em] text-[var(--ink-2)] font-sans">
          Password requirements
        </span>
        <span
          className={cn(
            "text-[11.5px] font-semibold font-sans",
            complete ? "text-[var(--success)]" : "text-[var(--muted)]"
          )}
          /* Announced politely so a screen reader hears progress without the
             whole list being re-read on every keystroke. */
          aria-live="polite"
        >
          {score} / {total}
        </span>
      </div>

      <ul className="grid gap-1.5 m-0 p-0 list-none">
        {PASSWORD_RULES.map((rule) => {
          const ok = rule.test(value);
          return (
            <li
              key={rule.id}
              className={cn(
                "flex items-center gap-2 text-[12.5px] leading-[1.4] font-sans",
                ok ? "text-[var(--success)] font-semibold" : "text-[var(--ink-2)] font-medium"
              )}
            >
              <span
                aria-hidden="true"
                className={cn(
                  "w-4 h-4 rounded-full shrink-0 flex items-center justify-center border-[1.5px] text-white",
                  ok
                    ? "bg-[var(--success)] border-[var(--success)]"
                    : "bg-white border-[var(--line-2)]"
                )}
              >
                {ok && <CheckIcon size={10} stroke="#fff" />}
              </span>
              <span>{rule.label}</span>
              {/* The tick is decorative, so state is carried in text for AT. */}
              <span className="sr-only">{ok ? " — met" : " — not met"}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PasswordRequirements;
